import {
  TablePage,
} from 'src/views/abi/billing-record-admin'
import pathMap from 'src/paths/pathMap'

class AbiBillingRecordAdminRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_BILLING_RECORD_ADMIN_PATH,
        component: TablePage
      }
    ]
  }
}

export default AbiBillingRecordAdminRoute
